var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"size":_vm.bottonObj.size,"type":_vm.bottonObj.type,"plain":_vm.bottonObj.plain,"round":_vm.bottonObj.round,"circle":_vm.bottonObj.circle,"loading":_vm.loading,"disabled":_vm.bottonObj.disabled,"icon":_vm.bottonObj.icon},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.bottonObj.text || '下载'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }